import {BaseMetadataModel} from "../../../../infrastructure/models/base-metadata-model";

export class LogoMetadataModel extends BaseMetadataModel {
  get alt(): String {
    const title = this.terms.WEB_365SCORES;

    return title;
  }

  get title(): String {
    const title = this.terms.HOMEPAGE_TITLE_TEMPLATE?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
    });

    return title;
  }
}
